
// nova API requests
function initNova() {
    const novaPoshta = document.querySelector('#nova-poshta');
    const contactYou = document.querySelector('#contact-you');
    const addressWrap = novaPoshta.querySelector('.address-wrap');
    const searchWrap = novaPoshta.querySelector('.search-wrap');
    const warehouseWrap = novaPoshta.querySelector('.warehouse-wrap');
    const cityFilter = novaPoshta.querySelector('#city_filter');
    const citySearch = novaPoshta.querySelector('#city-search');
    const warehouseFilter = novaPoshta.querySelector('#warehouse_filter');
    const streetFilter = novaPoshta.querySelector('#street_filter');

    const apiKey = window.apiKeyNova;
    const apiUrlN = 'https://api.novaposhta.ua/v2.0/json/ ';

    // document.querySelectorAll('#variant_telegram, #variant-self-delivery').forEach(function (it) {
    //     it.checked = true;
    // });

    quickCityLink();
    clearFields();
    deliveryMethod();
    initCartUrl();

    async function reqAPI(data) {
        try {
            const response = await fetch(apiUrlN, {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'same-origin',
                cache: 'no-cache',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.json();
        } catch (error) {
            //throw error;
            console.log('error');
        }
    }

    novaPoshta.querySelectorAll('input.form-control').forEach(function(item) {
        item.addEventListener('input', function() {
            if (item.value != '') {
                if (item.classList.contains('input-city')) {
                    item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                    let customerCity = item.value;
                    reqAPI({
                        "apiKey": apiKey,
                        "modelName": "Address",
                        "calledMethod": "searchSettlements",
                        "methodProperties": {
                            "CityName": customerCity,
                            "Limit": "99",
                            "Page": "1"
                        }
                    })
                        .then(res => {
                            if (res.success) {
                                let dataCities = res.data[0].Addresses;
                                cityFilter.innerHTML = '';
                                if (dataCities.length > 0) {
                                    dataCities.forEach(function(item, i) {
                                        cityFilter.insertAdjacentHTML('beforeend', `
                                                <a class="filter-link city-link link" data-city="${item.MainDescription}" data-delivery-ref="${item.DeliveryCity}" data-ref="${item.Ref}" data-present="${item.Present}" style="display:block;">${item.Present}</a>
                                            `)
                                    })
                                }
                                cityFilter.classList.add('active');
                                cityFilterLink();
                            }
                        })
                        .catch(err => {
                            console.log('error request:', this, 'err', err)
                        })
                }
                else if (item.classList.contains('input-warehouse') && citySearch.value != '') {
                    item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                    let findString = item.value;
                    let CityRef = citySearch.dataset.deliveryRef;
                    reqAPI({
                        "apiKey": apiKey,
                        "modelName": "Address",
                        "calledMethod": "getWarehouses",
                        "methodProperties": {
                            "FindByString": findString,
                            "CityRef": CityRef,
                            "Page": "1",
                            "Limit": "99"
                        }
                    })
                        .then(res => {
                            if (res.success) {
                                let warehouses = res.data;
                                warehouseFilter.innerHTML = '';
                                warehouses.forEach(function(item, i) {
                                    warehouseFilter.insertAdjacentHTML('beforeend', `
                                            <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.Description}' style="display:block;">${item.Description}</a>
                                        `)
                                })
                                warehouseFilter.classList.add('active');
                                cityFilterLink();
                            }
                        })
                        .catch(err => {
                            console.log('error request:', this)
                        })
                }
                else if (item.classList.contains('input-street') && citySearch.value != '') {
                    item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                    let findString = item.value;
                    let сityRef = citySearch.dataset.deliveryRef;
                    reqAPI({
                        "apiKey": apiKey,
                        "modelName": "Address",
                        "calledMethod": "getStreet",
                        "methodProperties": {
                            "CityRef": сityRef,
                            "FindByString": findString,
                            "Page": "1",
                            "Limit": "99"
                        }
                    })
                        .then(res => {
                            if (res.success) {
                                let dataStreets = res.data;
                                streetFilter.innerHTML = '';
                                dataStreets.forEach(function(item, i) {
                                    streetFilter.insertAdjacentHTML('beforeend', `
                                            <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.StreetsType} ${item.Description}' style="display:block;">${item.StreetsType} ${item.Description}</a>
                                        `)
                                })
                                streetFilter.classList.add('active');
                                cityFilterLink();
                            }
                        })
                        .catch(err => {
                            console.log('error request:', this)
                        })
                }
            } else {
                item.dataset.ref = '';
                if (item.closest('.form-group').querySelector('.clear') !== null) {
                    item.closest('.form-group').querySelector('.clear').classList.add('d-none')
                }
                item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
                item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
            }
        })
    })

    function clearFields() {
        novaPoshta.querySelectorAll('.clear').forEach(function(item) {
            item.addEventListener('click', function() {
                item.classList.add('d-none');
                item.closest('.branch_wrap').querySelector('input').value = '';
                item.closest('.branch_wrap').querySelector('input').dataset.ref = '';
                item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
                item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active')
            });
        });
    }

    function quickCityLink() {
        novaPoshta.querySelectorAll('a.quick-city-link').forEach(function(item) {
            let startCity = item.textContent;
            reqAPI({
                "apiKey": apiKey,
                "modelName": "Address",
                "calledMethod": "searchSettlements",
                "methodProperties": {
                    "CityName": startCity,
                    "Limit": "99",
                    "Page": "1"
                }
            })
                .then(res => {
                    if (res.success) {
                        item.dataset.ref = res.data[0].Addresses[0].Ref;
                        item.dataset.deliveryRef = res.data[0].Addresses[0].DeliveryCity;
                        item.dataset.present = res.data[0].Addresses[0].Present;
                    }else{
                        console.log('ERRORS', res.errors)
                    }
                })
                .catch(err => {
                    console.log('error request:', this)
                })
            item.addEventListener('click', function(e) {
                if (e.target.closest('.quick-city-link')) {
                    novaPoshta.querySelector('.city-wrap input').value = e.target.dataset.present;
                    novaPoshta.querySelector('.city-wrap input').dataset.ref = e.target.dataset.ref;
                    novaPoshta.querySelector('.city-wrap input').dataset.deliveryRef = e.target.dataset.deliveryRef;
                    novaPoshta.querySelector('.city-wrap .clear').classList.remove('d-none');
                }
            })
        })
    }

    function cityFilterLink() {
        novaPoshta.querySelectorAll('a.filter-link').forEach(function(item) {
            item.addEventListener('click', function(e) {
                if (e.target.dataset.deliveryRef) {
                    item.closest('.branch_wrap').querySelector('.form-group input').dataset.deliveryRef = e.target.dataset.deliveryRef;
                }
                if (e.target.dataset.city) {
                    item.closest('.branch_wrap').querySelector('.form-group input').dataset.city = e.target.dataset.city;
                }
                item.closest('.branch_wrap').querySelector('.form-group input').dataset.ref = e.target.dataset.ref;
                item.closest('.branch_wrap').querySelector('.form-group input').value = e.target.dataset.present;
                item.closest('.branch_wrap').querySelector('.form-group .clear').classList.remove('d-none');
                item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
                item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
            })
        })
    }

    function deliveryMethod() {
        document.querySelectorAll('[name="variant"]').forEach(function(item) {
            item.addEventListener('change', function(e) {
                if (e.target.closest('#variant-branch')) {
                    searchWrap.classList.remove('hide');
                    addressWrap.classList.add('d-none');
                    warehouseWrap.classList.remove('d-none');
                    novaPoshta.querySelector('#address-street').value = '';
                    novaPoshta.querySelector('#address-street').dataset.ref = '';
                    novaPoshta.querySelector('#address-build').value = '';
                    novaPoshta.querySelector('#address-flat').value = '';
                    addressWrap.querySelector('.clear').classList.add('d-none');
                } else if (e.target.closest('#variant-courier')) {
                    searchWrap.classList.remove('hide');
                    addressWrap.classList.remove('d-none');
                    warehouseWrap.classList.add('d-none');
                    novaPoshta.querySelector('#warehouse-search').value = '';
                    novaPoshta.querySelector('#warehouse-search').dataset.ref = '';
                    warehouseWrap.querySelector('.clear').classList.add('d-none');
                }else{
                    searchWrap.classList.add('hide');
                }
            })
        })
    }

    function initCartUrl() {
        let inputsData = document.querySelectorAll('#nova-poshta .form-control');
        let inputsTypeShip = document.querySelectorAll('#nova-poshta input[name="variant"]');
        let buttCartLink = document.querySelector('#nova-poshta .nova-poshta__button-wrapper');
        buttCartLink.addEventListener('click', function(e) {
            e.preventDefault();
            if (novaPoshta.querySelector('.dropdown-filter.active') == null) {
                var contactYouParameter = contactYou.querySelector('[name="contact_you"]:checked');
                let valueContact = contactYouParameter.value;
                inputsTypeShip.forEach(function(inputTypeShip, i) {
                    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
                        .then(response => response.json())
                        .then(data => {
                            return data
                        });
                    if (inputTypeShip.checked && inputTypeShip.dataset.type == 'branch' && checkInputs('branch') == 2) {
                        let arrInputs = checkInputs('branch', true);
                        if (arrInputs) {
                            let linkCheckout;
                            cartContents.then((value) => {
                                let cart = value;
                                let link = 'http://' + window.Shopify.shop + '/cart/';
                                cart.items.forEach((item, i) => {
                                    link += item.variant_id + ':' + item.quantity
                                    if (i != cart.items.length - 1) {
                                        link += ','
                                    }
                                })
                                link += '?' + 'checkout[shipping_address][city]=' + arrInputs[0].value + '&checkout[shipping_address][address1]=' + arrInputs[1].value + '&checkout[shipping_address][zip]=12345';
                                if(valueContact != undefined){
                                    link += '&checkout[shipping_address][company]=' + valueContact;
                                }

                                // window.open(link, '_top')

                                function showLoadingOverlay() {
                                    const overlay = document.createElement('div');
                                    overlay.className = 'loading-overlay';
                                    overlay.id = 'custom-loading-overlay';
                                    document.body.appendChild(overlay);
                                }
                                function hideLoadingOverlay() {
                                    const overlay = document.getElementById('custom-loading-overlay');
                                    if (overlay) overlay.remove();
                                }

                                showLoadingOverlay();
                                document.body.style.cursor = 'progress';
                                const iframe = document.createElement('iframe');
                                iframe.style.display = 'none';
                                iframe.src = link;
                                document.body.appendChild(iframe);

                                setTimeout(() => {
                                    document.body.removeChild(iframe);
                                    location.href = link;
                                    document.body.style.cursor = 'default';
                                    hideLoadingOverlay();
                                }, 3000);
                            })

                        }
                    }
                    else if (inputTypeShip.checked && inputTypeShip.dataset.type == 'courier' && checkInputs('courier') == 4) {
                        let checkedInputs = checkInputs('courier', true);
                        if (checkedInputs) {
                            let linkCheckout;
                            cartContents.then((value) => {
                                let cart = value;
                                let link = 'http://' + window.Shopify.shop + '/cart/';
                                cart.items.forEach((item, i) => {
                                    link += item.variant_id + ':' + item.quantity
                                    if (i != cart.items.length - 1) {
                                        link += ','
                                    }
                                })
                                link += '?' + 'checkout[shipping_address][city]=' + checkedInputs[0].value + '&checkout[shipping_address][address1]=' + checkedInputs[1].value + ', буд. ' + checkedInputs[2].value + ', кв. ' + checkedInputs[3].value + '&checkout[shipping_address][zip]=12345';
                                if(valueContact != undefined){
                                    link += '&checkout[shipping_address][company]=' + valueContact;
                                }
                                window.open(link, '_top');
                            })
                        }
                    }
                    else if(inputTypeShip.checked && inputTypeShip.dataset.type == 'self-delivery'){
                        cartContents.then((value) => {
                            let cart = value;
                            let link = 'http://' + window.Shopify.shop + '/cart/';
                            cart.items.forEach((item, i) => {
                                link += item.variant_id + ':' + item.quantity
                                if (i != cart.items.length - 1) {
                                    link += ','
                                }
                            })
                            let text = window.translation.from_self_delivery;
                            let address1 = window.store_address.address1;
                            let address2 = window.store_address.address2;
                            let city = window.store_address.city;
                            link += '?' + 'checkout[shipping_address][city]=' + city + '&checkout[shipping_address][address1]=' + text + address1 + '&checkout[shipping_address][zip]=12345';
                            if(valueContact != undefined){
                                link += '&checkout[shipping_address][company]=' + valueContact;
                            }
                            window.open(link, '_top');
                        })
                        // document.querySelector('[data-cart-footer] [name="checkout"]').click();
                    }else if(inputTypeShip.checked && inputTypeShip.dataset.type == 'branch' && checkInputs('branch') != 2 || inputTypeShip.checked && inputTypeShip.dataset.type == 'courier' && checkInputs('courier') != 4){
                        let enter_data = window.translation.enter_data;
                        alert(enter_data);
                        return false;
                    }
                })
            }
        })

        function checkInputs(type, inputs) {
            if (type == 'branch') {
                let branch = 0;
                let arr = [];
                inputsData.forEach((item) => {
                    if ((item.id == 'city-search' || item.id == 'warehouse-search') && item.value != '') {
                        branch++;
                        arr.push(item);
                    }
                })
                if (inputs == true) {
                    return arr;
                } else {
                    return branch;
                }
            } else if (type == 'courier') {
                let courier = 0;
                let arr = [];
                inputsData.forEach((item) => {
                    if ((item.id == 'city-search' || item.id == 'address-street' || item.id == 'address-build' || item.id == 'address-flat') && item.value != '') {
                        courier++;
                        arr.push(item);
                    }
                })
                if (inputs == true) {
                    return arr;
                } else {
                    return courier;
                }
            }
        }
    }

}
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('#nova-poshta') !== null && document.querySelector('.nova-feature-btn__wrapper') == null) {
        document.querySelector('[data-cart-footer] .delivery-button').addEventListener('click', function () {
            initNova();
        })
        document.querySelector('[data-cart-footer] button.custom-goto-nova').addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('#nova-poshta').classList.add('active');
            initNova();
        })
    }
    if(document.querySelector('#contact-you') !== null){
        document.querySelector('[data-cart-footer] .contact-button').addEventListener('click', function () {
            initNova();
        })
    }
});
// nova API requests END
